import ModelUpdate from "@/models/ModelUpdate";
import {IGlobalConfigAdmin} from "@/models/global-config/GlobalConfigAdminModels";
import {ValidationRule} from "@/declarations/ValidationRule";

export default class GlobalConfigUpdateExternalSource extends ModelUpdate<IGlobalConfigAdmin> {

	public privateCustomerExternalId!: string | null;

	public constructor(model: IGlobalConfigAdmin) {
		super();
		this.setDetailModel(model);
	}

	protected initializeWithDetailModelData(detailModel: IGlobalConfigAdmin): void {
		this.privateCustomerExternalId = detailModel.privateCustomerExternalId;
	}

	public rules(): ValidationRule[] {
		return [];
	}

}
